const HELP_TYPE = {
    ZTUDENT: {
        DASHBOARD: 1,
        COURSE: 13,
        RESULTS: 14,
        RESULTS_ITEMS: 17,
        VIEWER: 15
    },
    INSTRUCTOR: {
        DASHBOARD: 2,
        GROUPS: 3,
        GROUPS_CREATE: 4,
        GROUP: 5,
        ZTUDENTS: 6,
        CHANGE_GROUP: 7,
        AGENDA: 8,
        AGENDA_CREATE: 16,
        PROGRESS: 9,
        RESULTS: 10,
        ZTUDENTVIEW: 11,
        SYLLABUS: 12
    },
    LEADER: {
        DASHBOARD: 18
    }
}

export { HELP_TYPE };